import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "form"]
  
  connect() {
    this.isUploading = false
  }

  browse() {
    if (!this.isUploading) {
      this.inputTarget.click()
    }
  }

  handleFileSelect(event) {
    if (this.isUploading) return
    this.isUploading = true
    
    const file = event.target.files[0]
    if (file) {
      this.processFile(file)
    }
  }

  processFile(file) {
    if (!file.type.match('image.*')) {
      alert('Please select an image file')
      this.isUploading = false
      return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      const img = new Image()
      img.onload = () => {
        img.classList.add('w-24', 'h-24', 'rounded-xl', 'object-cover')
        this.previewTarget.innerHTML = ''
        this.previewTarget.appendChild(img)
        this.formTarget.requestSubmit()
        this.isUploading = false
      }
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  }
}
